export default __webpack_public_path__ + "static/media/akan_asanga.bc2883dd.jpg";